import { createSlice } from '@reduxjs/toolkit';

// Correctly initialize initialState with type annotation
const initialState = {
  usercart: [],
};

const cartuserSlice = createSlice({
  name: 'usercart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      state.usercart = action.payload;
    },

    removeFromCart: (state, action) => {
      const { projectGuID, isApiData } = action.payload;

      // Remove item from cart based on projectGuID
      if (isApiData) {
        // Add logic to remove item from API data
        // For example:
        // API.delete(`/cart/${projectGuID}`);
      } else {
        // Remove item from local storage
        state.usercart = state.usercart.filter((item) => item.projectGuID !== projectGuID);
      }
    },
  },
});

export const { addToCart, removeFromCart } = cartuserSlice.actions;
export default cartuserSlice.reducer;
